import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import { useObservationsSection } from '../context/ObservationsSectionContext';
import ObservationsSectionTable from './ObservationsSectionTable';

const ObservationsSectionBody: FC = () => {
  const { data, actions } = useObservationsSection();

  const showPagination =
    data.observations && data.observationsTotal > (data.rowsPerPage || 10);

  return (
    <div className="mt-4">
      {data.isLoadingObservations ? (
        <TableSkeleton
          rows={10}
          columns={4}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <ObservationsSectionTable />
      )}

      {showPagination && (
        <TablePagination
          totalRows={data.observationsTotal || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};
export default ObservationsSectionBody;
